import React from 'react';
import { Tooltip, TooltipDirections } from 'ui/common/tooltip/tooltip';
import { Tag } from 'app/components/tag';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/favourite-administration/list/types-store';
import { ids } from 'app/area/administration/constants';
import { SearchTile, TileLink } from 'app/components/search-tile';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { FavouriteInfo } from 'app/area/favourite-administration/list/search-tile';
import { isDisabled } from 'app/infrastructure/data/date';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { canDelete, isCodeExtra } from 'app/area/favourite-administration/form/components/helpers';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, deleteFavourite, translation
}) => {

  const handleDelete = () => {
    deleteFavourite(
      item.code.value,
      replaceTemplateString(translation.favourite_deleted, item.code.description)
    );
  };

  return <SearchTile
    componentId={ids.search.tile}
    className={item?.invalidOwner ? styles.error : undefined}
    footer={<FavouriteInfo
      id={item.code.value}
      owner={item.owner?.value && item.owner?.description}
      parent={item?.parent?.description} />}
    deleted={undefined}>

    <div className={styles.content}>
      <div className={styles.leftSide}>
        {isCodeExtra(item.code.codeExtra) ? <div className="large-icon folder-large" /> : null}
        <TileLink
          url={routeConstants.favouriteAdminItemFor(item.code.value)}
          title={item.code.description} />
      </div>
      <div className={styles.rightSide}>
        {item.shared ? <Tag className={styles.tag}>{translation.shared}</Tag> : null}
        {isDisabled(item.disabled) ? <Tag className={styles.tag}>{translation.disabled}</Tag> : null}
        {item?.invalidOwner
          ? <Tooltip
            direction={TooltipDirections.top}
            title={translation.invalid_owner_warning}
            className={styles.tooltip}>
            <div className={styles.warningIcon} />
          </Tooltip>
          : null}
      </div>
    </div>

    {canDelete(item.code?.value)
      ? <MeatballMenu className={styles.meatballMenu}>
        <li>
          <PromptConfirmationModal
            title={translation.delete_favourite_title}
            description={replaceTemplateString(
              translation.delete_confirmation,
              item.code?.description)}
            continueText={translation.delete_favourite_button}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button"
              className="dropdown-item"
              disabled={deleting}>
              {translation.delete_favourite_button}
            </button>
          </PromptConfirmationModal>
        </li>
      </MeatballMenu> : null}
  </SearchTile>;
};
